/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Tab_LibraryInputs */



/**
* | output |
* | --- |
* | "Practice library" |
*
* @param {Practice_Tab_LibraryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_tab_library = /** @type {((inputs?: Practice_Tab_LibraryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Tab_LibraryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefenbibliotheek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bibliothèque d'entraînement")
	return /** @type {LocalizedString} */ ("Practice library")
});